import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faSpinner, IconDefinition } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent {

  @Input() iconSrc          !:string;
  @Input() loadingIcon      : boolean = false;
  @Input() className        !: string;
  @Input() toolTip          !: string;
  @Input() placement          !: string;
  @Input() faIcon           : IconDefinition | undefined;
  @Input() text             !: string;
  @Output() clickEvent      : EventEmitter<any> = new EventEmitter<void>();

  protected readonly faSpinner = faSpinner;

  onClickEvent(event: any) {
    if(!this.loadingIcon){
      this.clickEvent.emit();
    }
  }

}
